(function() {

    $(document).on('click', '.checkbox input[type=checkbox]', function() {
        $(this).parent().toggleClass('checked');
    });

    $('.checkbox input:checkbox:checked').parent().addClass('checked');

    $(document).on('click', '.smp-input input:radio', function() {
        $(this).parent().toggleClass('active');
    });

    $('.smp-input input:radio:checked').parent().addClass('active');

})($);
